module.exports = __webpack_public_path__ + "static/msp@3x-2d4dc559b372cb3c9cacaa03729209b6.png";